import script from "./RecipesMainScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipesMainScreen.vue?vue&type=script&setup=true&lang=js"

import "./RecipesMainScreen.vue?vue&type=style&index=0&id=1ef1ff02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef1ff02"]])

export default __exports__